const SuiteActions = {
    UPDATE: 'UPDATE_SUITES',
    UPDATE_PRIMARY_SUITES: 'UPDATE_PRIMARY_SUITES',
    UPDATE_UNOCCUPIED_SUITES: 'UPDATE_UNOCCUPIED_SUITES'
}

export default SuiteActions;